<template>
  <div class="store-finder">
    <div class="title">
      <h1>查找鬼塚虎店铺</h1>
    </div>
    <div class="finder-main" id="container">
      <div class="tiger-finder">
        <div class="search-form">
          <input type="text" v-model.trim="kw" placeholder="请输入查询的店铺名或店铺地址" />
          <button class="button black" @click="toSearch">搜索</button>
        </div>
      </div>
      <div class="store-map clearfix">
        <div class="map-area" id="map-area">
          <div v-if="stores.items && stores.items.length" class="store-pagination">
            <div class="page-prev">
              <a class="fake-btn" @click="go(-1)" v-if="currPage != 1">&lt; 前一页</a>
            </div>
            <div class="page-next">
              <a class="fake-btn" @click="go(1)" v-if="stores.hasNext">下一页 &gt;</a>
            </div>
          </div>
          <div class="store-list">
            <ul>
              <li class="store-item" v-for="(item) in stores.items" :key="`Store-${item.lat}`">
                <div class="brand-index Outlet Store">{{ item.index }}</div>
                <div class="brand-text">
                  <h4>
                    <a v-if="enableDirection" :href="setDirection(item)" class="store-info-1" target="_blank"
                      :title="item.title">{{ item.title }}</a>
                    <a v-else href="javascript:;" class="store-info-1" :title="item.title" @click="showInfoWin(item)">{{
                      item.title }}</a>
                  </h4>
                  <div class="address">
                    <span class="street-address" v-if="item.businessScope">销售系列：{{ item.businessScope }} <br /></span>
                    <span class="street-address">详细地址：{{ item.address }}</span>
                    <br />
                    <span class="locality">{{ item.city }}</span>
                    <span class="region">{{ item.region }}</span>
                    <span class="postal-code">{{ item.postcode }}</span>
                    <br />
                    <a class="fake-btn view-info" @click="showInfoWin(item)">查看店铺详情</a>
                    <br />
                    <!-- <a v-if="enableDirection" :href="setDirection(item)" class="js-t-get-direction"
                      target="_blank">查找地址</a>
                    <a v-else :href="setDirection(item)" class="js-t-get-direction"
                      target="_blank">查找地址</a> -->
                    <a :href="setDirection(item)" class="js-t-get-direction" target="_blank">查找地址</a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="stores.items && stores.items.length" class="store-pagination">
            <div class="page-prev" v-if="currPage != 1">
              <a class="fake-btn" @click="go(-1)">&lt; 前一页</a>
            </div>
            <div class="page-next" v-if="stores.hasNext">
              <a class="fake-btn" @click="go(1)">下一页 &gt;</a>
            </div>
          </div>
        </div>
        <div id='map' class='map-canvas'>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/utils/api';
import types from '@/store/types';
import utils from '@/utils';
import { captureManualError } from '@/sentry/index'
export default {
  data() {
    return {
      map: {
        key: process.env.VUE_APP_TMAP_KEY,
        center: { lat: "31.236176", lng: "121.479965" },
        zoom: 12,
        width: "75%",
        height: "660px"
      },
      allStores: [],
      queryString: "",
      kw: "",
      currPage: 1,
      currPosition: null,
      multiMarker: null,
      tMap: null,//腾讯地图实例
      TXMap: null, // 腾讯地图原型
      markersData: [], // 标记数据
      infoWin: null, // 信息窗口实例
      infoWindow: null, // 窗口信息
    };
  },
  created() {
    this.loadStores();
  },
  mounted() {
   // 判断如果不是移动端，则加载地图
   if (!utils.isMobile() && !utils.isWXBrowser()) {
    this.loadTMapSDK().then(() => {
      this.initMap()
    }).catch(err => {
      console.error('Failed to load TMap SDK:', err)
      captureManualError(err)
    })
  }
  },
  methods: {
    loadTMapSDK() {
      return new Promise((resolve, reject) => {
        // Check if TMap is already loaded
        if (window.TMap) {
          resolve()
          return
        }

        // Check if loading is in progress
        if (window.TMapLoadingPromise) {
          return window.TMapLoadingPromise
        }

        // Create a new loading promise
        window.TMapLoadingPromise = new Promise((loadResolve, loadReject) => {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${process.env.VUE_APP_TMAP_KEY}&referer=onitsukatiger`
          script.charset = 'utf-8'
          script.onload = () => {
            loadResolve()
          }
          script.onerror = () => {
            loadReject(new Error('Failed to load TMap SDK'))
          }
          document.head.appendChild(script)
        })

        window.TMapLoadingPromise.then(() => {
          resolve()
        }).catch(loadReject => {
          reject(loadReject)
        })
      })
    },
    initMap() {
      if (!window.TMap) {
        console.error('TMap SDK not loaded')
        return
      }

      try {
        const center = new window.TMap.LatLng(this.map.center.lat, this.map.center.lng)
        // eslint-disable-next-line no-unused-vars
        this.tMap = new window.TMap.Map(document.getElementById('map'), {
          resizeEnable: true,
          center: center,
          zoom: 12,
          pitch: 50,
          // rotation: 45,
        })
        this.infoWindow = new window.TMap.InfoWindow({
          map: this.tMap,
          position: center,
          offset: {
            x: 0,
            y: -20,
          }
        }).close()

        // Render markers if stores are already loaded
        if (this.allStores.length > 0) {
          this.renderMarker()
        }
      } catch (error) {
        console.error('Error initializing map:', error)
        captureManualError(error)
      }
    },

    handleMarker() {
      if (!window.TMap) {
        console.error('TMap SDK not loaded')
        return []
      }

      let myMarkers = []
      this.stores?.items?.map((item, index) => {
        try {
          let obj = {
            id: index,
            styleId: 'marker',
            position: new window.TMap.LatLng(item.lat, item.lng),
            content: `${item.index}`,
            properties: { ...item },
          }
          myMarkers.push(obj)
        } catch (error) {
          console.error('Error creating marker:', error)
        }
      })
      return myMarkers
    },
    // 渲染marker
    renderMarker() {
      if (!window.TMap || !this.tMap) {
        console.error('TMap SDK or map instance not loaded')
        return
      }

      try {
        const markerArr = this.handleMarker()
        let map = this.tMap
        this.multiMarker = new window.TMap.MultiMarker({
          // id: 'marker-layer',
          map: map,
          styles: {
            "default": new window.TMap.MarkerStyle({//这里的marker改成default 换掉默认的样式
              "width": 35,
              "height": 45,
              color: '#fff',
              size: 18, // 标注点文本文字大小
              strokeWidth: 2,
              "anchor": { x: 16, y: 38 },
              "src": 'https://assetsprod.onitsukatiger.com/assets/Logo/point.png'
            })
          },
          geometries: markerArr,
        })
        this.multiMarker?.on('click', (evt) => {
          const data = {
            title: evt.geometry.properties?.title,
            address: evt.geometry.properties?.address,
            tel: evt.geometry.properties?.tel,
            type: evt.geometry.properties?.type,
            position: evt.geometry.position,
          }
          this.showInfo(data)
        })
      } catch (error) {
        console.error('Error rendering markers:', error)
        captureManualError(error)
      }
    },
    showInfo(evt) {
      let content = `
          <div class='map-info2'>
            <p>${evt.title}</p>
            ${evt?.businessScope ? `<p>销售系列：${evt.businessScope}</p>` : ''}
            <p>详细地址：${evt.address}</p>
            <p>营业时间：${evt.businessHours || '10:00 AM - 10:00 PM'}</p>
            <p>联系方式：${evt.tel}</p>
            ${evt?.type ? `<p>店铺类型：${evt.type}</p>` : ''}
          </div>
        `
      this.infoWindow.open()
      this.infoWindow.setPosition(evt.position) // 设置信息窗口的坐标
      this.infoWindow.setContent(content) // 设置信息窗口的内容
    },
    loadStores() {
      api[types.GET_OSS_STORES]().then(res => {
        this.allStores = res.data;
        // Render markers if map is already initialized
        if (this.tMap && window.TMap) {
          this.renderMarker()
        }
        // If map isn't initialized yet, initMap will handle rendering markers
      }).catch(err => {
        console.warn(err);
        captureManualError(err)
      });
    },
    // 页码跳转
    go(ref) {
      this.currPage += ref;
      // 设置地图中心为第一条记录的位置
      this.$nextTick(() => {
        if (!this.stores?.items?.[0]) {
          return;
        }

        if (!window.TMap || !this.tMap) {
          console.error('TMap SDK or map instance not loaded');
          return;
        }

        try {
          let { lng, lat } = this.stores.items[0];
          const center = new window.TMap.LatLng(lat, lng)
          this.tMap.setCenter(center)
          this.renderMarker()
        } catch (error) {
          console.error('Error updating map center:', error)
          captureManualError(error)
        }
      });
    },
    //查询
    toSearch() {
      this.queryString = this.kw;
      this.currPage = 1;
      // 设置地图中心为第一条记录的位置
      this.$nextTick(() => {
        if (!this.stores?.items?.[0]) {
          this.$message({ message: '暂未查询到相关门店，请重新搜索' })
          return;
        }

        if (!window.TMap || !this.tMap) {
          console.error('TMap SDK or map instance not loaded');
          return;
        }

        try {
          let { lng, lat } = this.stores.items[0];
          const center = new window.TMap.LatLng(lat, lng)
          this.tMap.setCenter(center)
          this.renderMarker()
        } catch (error) {
          console.error('Error updating map center:', error)
          captureManualError(error)
        }
      });
    },

    // 查看详情
    showInfoWin(data) {
      if (!window.TMap || !this.tMap) {
        console.error('TMap SDK or map instance not loaded')
        return
      }

      try {
        const center = new window.TMap.LatLng(data.lat, data.lng)
        this.tMap.setCenter(center)
        this.showInfo({ ...data, position: center })
      } catch (error) {
        console.error('Error showing info window:', error)
        captureManualError(error)
      }
    },

    setDirection(store) {
      if (store) {
        const s = store;
        if (this.enableDirection) {
          return `https://apis.map.qq.com/uri/v1/geocoder?coord=${s.lat},${s.lng};title:${s.title};addr:${s.address}&referer=${process.env.VUE_APP_TMAP_KEY}`
        } else {
          return `https://apis.map.qq.com/uri/v1/marker?marker=coord:${s.lat},${s.lng};title:${s.title};addr:${s.address}&referer=${process.env.VUE_APP_TMAP_KEY}`
        }
      }
      return "";
    }
  },
  computed: {
    stores() {
      if (!Array.isArray(this.allStores) || !this.allStores.length) return { items: [], total: 0, hasNext: false };
      let currPage = this.currPage;
      let allStores = Array.from(this.allStores);
      let kw = this.queryString;
      let ret = {
        stores: [],
        total: 0,
        hasNext: false
      };
      let matched = [];
      // 过滤筛选
      if (Array.isArray(allStores)) {
        if (kw) {
          matched = allStores.filter(store => {
            if (
              store.title.toLowerCase().indexOf(kw.toLowerCase()) != -1 ||
              store.address.toLowerCase().indexOf(kw.toLowerCase()) != -1 ||
              store.country.toLowerCase().indexOf(kw.toLowerCase()) != -1 ||
              store.region.toLowerCase().indexOf(kw.toLowerCase()) != -1 ||
              store.city.toLowerCase().indexOf(kw.toLowerCase()) != -1
            ) {
              return true;
            } else {
              return false;
            }
          });
          ret.total = ret.stores.length
        } else {
          matched = Array.from(this.allStores);
        }
      }
      // 补充序号、Icon等字段
      matched.forEach((item, index) => {
        item.index = index + 1;
        item.icon = {
          size: { width: 50, height: 54 },
          opts: {
            imageSize: { width: 500, height: 540 },
            imageOffset: { width: -(index % 10) * 50, height: -parseInt(index / 10) * 54 }
          }
        };
      });
      // 总记录数
      ret.total = matched.length;
      // 是否有下一页
      let totalPage = Math.ceil(ret.total / 10);
      if (totalPage <= currPage) {
        ret.hasNext = false;
      } else {
        ret.hasNext = true;
      }
      // 分页处理
      if (matched.length > 10) {
        matched = matched.splice((currPage - 1) * 10, 10);
      }
      ret.items = matched;
      // 
      // let { lat, lng } = matched?.[0];
      // this.map.center = { lat, lng };
      // 

      return ret;
    },
    enableDirection() {
      return utils.isMobile() || utils.isWXBrowser();
    }
  }
};
</script>

<style lang="scss" scoped>
.fake-btn {
  cursor: pointer;
}

.map-canvas {
  z-index: 1;
}

::v-deep .map-info2 {
  text-align: left;
}

::v-deep .rotate-circle {
  .rotate-top-img {
    top: 11px !important;
    left: 9px !important;
  }

  .rotate-bottom-img {
    top: 14px !important;
    left: 14px !important;
  }
}


.store-finder {
  width: 110rem;
  margin: 0 auto;
  clear: both;
  overflow: hidden;

  .title {
    text-align: center;
    margin: 20px 0;

    h1 {
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 400;
      font-size: 24px;
    }
  }

  .finder-main {
    .tiger-finder {
      padding: 25px 0;
      background-image: url("../../assets/imgs/store/search-bg.jpg");

      .search-form {
        padding: 15px;

        .hidden {
          display: none !important;
        }

        input[type="text"] {
          box-sizing: border-box;
          font-size: 1.2rem;
          font-style: italic;
          width: 70%;
          margin-right: 1%;
          padding: 10px;
          color: #666;
          border: 1px solid #ccc;
          line-height: 18px;
          vertical-align: top;
        }

        .button {
          font-size: 1.4rem;
          font-weight: 400;
          line-height: 2;
          background: #000;
          color: #fff;
          text-align: center;
          text-transform: uppercase;
          border: 0;
          width: 25%;
          padding: 8px 0 4px;
          cursor: pointer;
        }
      }
    }

    .store-map {
      position: relative;
      padding-bottom: 60px;

      a {
        color: #999;

        &:hover {
          text-decoration: underline;
        }
      }

      .map-area {
        width: 25%;
        height: 660px;
        overflow-y: scroll;
        background: hsla(0, 0%, 100%, 0.8);
        padding: 0;
        z-index: 999;
        float: left;

        .store-pagination {
          font-size: 1.2rem;
          position: relative;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          margin: 10px 15px 0;
          height: 45px;
          line-height: 45px;
          color: #333;

          a {
            color: #999;
          }

          .page-prev,
          .page-next {
            position: absolute;
            width: 30%;
            top: 0;
            cursor: pointer;
          }

          .page-prev {
            left: 0;
            text-align: left;
          }

          .page-next {
            right: 0;
            text-align: right;
          }
        }

        .store-list {
          margin-top: 10px;

          li {
            position: relative;
            padding: 0 10px 10px;
            margin: 0 0 5px;
            border-bottom: 1px solid #ddd;

            .brand-index {
              text-transform: uppercase;
              background: url("../../assets/imgs/store/brand-index.png") top no-repeat;
              width: 40px;
              height: 48px;
              position: absolute;
              text-align: center;
              padding-top: 10px;
              font-size: 1.2rem;
              color: #fff;
            }

            .brand-text {
              padding-left: 25%;

              h4 {
                font-size: 1.4rem;
                height: 30px;
                line-height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-transform: uppercase;
                text-align: left;

                a {
                  color: #000;
                  font-weight: bold;
                }
              }

              .address {
                font-size: 1.2rem;
                line-height: 1.8rem;
                text-align: left;

                span {
                  color: #333;
                }

                a {
                  font-size: 12px;
                }
              }
            }
          }
        }
      }

      .map-canvas {
        width: 75%;
        float: right;
        height: 660px;
      }

      .map-legend {
        position: absolute;
        left: 25%;
        bottom: 10px;
        height: 60px;
        line-height: 60px;

        .map-legend-label {
          font-family: 'MatterSQ', 'NotoSansCJKsc', 'DIN Next W01 Regular', Helvetica neue, Hiragino sans GB, sans-serif;
          font-size: 14px;
          color: #444;
          margin-top: 9px;
          margin-left: 15px;
          background-repeat: no-repeat;
          background-position: 0;
          padding-left: 35px;
          float: left;

          &.brandstore {
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAApCAYAAADJeCK0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDE0IDc5LjE1Njc5NywgMjAxNC8wOC8yMC0wOTo1MzowMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTE0QThGNjcxMTg5MTFFNTk2NTNFODFCODYyMEM2NTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTE0QThGNjgxMTg5MTFFNTk2NTNFODFCODYyMEM2NTQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFMTRBOEY2NTExODkxMUU1OTY1M0U4MUI4NjIwQzY1NCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFMTRBOEY2NjExODkxMUU1OTY1M0U4MUI4NjIwQzY1NCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ph032iQAAAISSURBVHjavJjPSgJRGMWvU0g9QBEVSUSrIKlFi4rAXUEr6QG0TQ/QKjCiFoYirtv0Bm2EFu2CqAiTykDERbSpFm1cppTa+eobMp25zuide+BwR+fO/fkd5v5BX6PREHYaXj40LyfhDTgEz8BjcB9cg1/hAnwOn8DP5kPvlzuW4/YLuRbgfXjV5j6BJ9hrcBI+g/fgrN2gPqtKUeEgmjS8RX2Ee9GgR/A2qv3oCAVwHM0pHBS9Kw+vA/xiCwVwFM0FPCXU6QleAfitDQrgAJpreE6o1z28CHCFPhhNN+IeAQWPG/9XKaqcxfUdv41eiabXPKp9NCuNeQw0p1fsp9KhpfgIT3BDeK86LSwECmsCmu9Q2OClTadChqJFwI2CBA1ohgYI6tcM9Rs8f3SqRtCyZmiZoEXN0KIh22w9UpagGc3QDEGveM/TIeJcGVj1aT1MaYKmiGeuucd8tPBSeeb8LvSgf6KJejhnv+AIc/52F3xBR4qER9Akxn9o3mqadcAHZ5Uq8LjCEopfU6UYFMZc41irtlAG5xTGnODxhBSqMOa2WKVQBTFbxtqp0l5jpudysoOSTN3EbBurUyjFs8lHR6dHzCg/1zVU8NaXdgilfrdOzqFOtAuXOvQpcT+hClrht7kuiTXC/ZRBSTeSmNN8X6iG2sXsONZuoa0xu4q1W2hrzK5idfqXjizmabexmvoWYACkoK3IuwUc4gAAAABJRU5ErkJggg==);
          }

          &.outletstore {
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAApCAYAAADJeCK0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDE0IDc5LjE1Njc5NywgMjAxNC8wOC8yMC0wOTo1MzowMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTc5RDMzOTgxMThFMTFFNTk2NTNFODFCODYyMEM2NTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTc5RDMzOTkxMThFMTFFNTk2NTNFODFCODYyMEM2NTQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxNzlEMzM5NjExOEUxMUU1OTY1M0U4MUI4NjIwQzY1NCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxNzlEMzM5NzExOEUxMUU1OTY1M0U4MUI4NjIwQzY1NCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsUAxhEAAAIOSURBVHjavJjPSgJRGMWvU0i9QWQkEa2CpBYtggJ3Bq2kB9A2PUBbI2ohKOK6TW/QRghyFwRGmFQGIi6ijbV1mVJq56tvyHTmOjPduQcOV5079+d3nPsHA/1+X9hpq/hqvlyAd+EovAyH4Am4C1OnGnwFn8Mv5k3XsZDluJNCrnX4GI7ZXCfwPHsbzsJF+Agu2w0asKoUFU6jycP71Ee4Fw16Ch+g2vexUADn0FzAEfF/VeEdgJu2UABn6aeAF4U6PdPQAL+NQAGcQnMDrwr1eoA3AG7TG2PgQtonoOBx038qRZUreH3PT6Nfoum1hmqfzEpTPgPN6ZX6rnTzsjnDE9wQ/qtHCwuB4pqA5jMUN3hp06mooWgRcKMIQcOaoWGCBjVDgwbPH53qErSlGdoiaF0ztG7INlufVCZoQTO0QNAS73k6RJySgVWf1sOcJmiOeOaae8ZHCz9VZc7PQg/6B5qkj3P2E04w53d3wQd0pMj4BM1i/MfBrWZQJ3xwVqkajyssofg2HYpBYcxdjrVjC2VwRWHMGR5PSKEKYx6JVQpVELNlrOMq/W/MdF9FdlCSyUvMtrE6hVI8e3x0dHrETPJ9nqGCt768Qyj1u3NyDnWiQ7gxpk+D+wlV0DY/zT1JrAnupwxKupXEnOfrQjXULmbHsXqFDsfsKlav0OGYXcXq9C8dWcxLbmM19SXAAMU8obBJeNM6AAAAAElFTkSuQmCC);
          }

          &.retailstore {
            background-image: url(data:image/png;base64,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);
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1100px) {
  .store-finder {
    padding: 0 15px;
    width: auto;
  }
}

@media only screen and (max-width: 768px) {
  .store-finder {
    .finder-main {
      .tiger-finder {
        .search-form {

          input[type=text],
          .button {
            width: 100%;
          }

          .button {
            margin-top: 25px;
          }
        }
      }

      .store-map {
        .map-area {
          width: 100%;
          float: none;
          height: auto;
          overflow-y: initial;

          .store-list {
            ul {
              li {
                .brand-text {
                  .address {
                    .view-info {
                      display: none;
                    }
                  }
                }
              }
            }
          }
        }

        .map-canvas,
        .map-legend {
          display: none;
        }
      }
    }
  }
}
</style>